import { FunctionComponent, useState } from 'react'
import {
  Box,
  IconButton,
  Menu,
  Typography,
  rucksack,
} from '@black-bear-energy/rucksack'
import { Groups2Rounded } from '@mui/icons-material'
import { SEARCH_MATCH_HIGHLIGHT } from 'components/helpers/constants'

export const PodMemberButton: FunctionComponent<PodMemberButtonProps> = ({
  constructionName,
  analystName,
  driverName,
  contractsName,
  searchString,
}: PodMemberButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const matchesSearch = searchString
    ? [constructionName, analystName, driverName, contractsName].some((name) =>
        name?.toLowerCase().includes(searchString.toLowerCase())
      )
    : false

  const podMemberTexts = [
    ...(analystName ? [`${analystName} (Analyst)`] : []),
    ...(driverName ? [`${driverName} (Driver)`] : []),
    ...(contractsName ? [`${contractsName} (Transactions)`] : []),
    ...(constructionName ? [`${constructionName} (Construction)`] : []),
  ]

  const text = podMemberTexts.join('\n')

  return (
    <Box sx={{ flexShrink: 0 }}>
      <Box
        sx={{
          background: matchesSearch ? SEARCH_MATCH_HIGHLIGHT : undefined,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '46px',
          height: '46px',
        }}
      >
        <IconButton
          sx={{
            padding: '5px',
            ...(open && {
              backgroundColor: rucksack.palette.action.focus,
            }),
            '&:hover': { backgroundColor: rucksack.palette.action.focus },
          }}
          onClick={handleClick}
          disabled={podMemberTexts.length === 0}
          disableRipple
          tabIndex={-1}
        >
          <Groups2Rounded />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: -4, horizontal: 'center' }}
          sx={{ '& .MuiList-root': { paddingY: 0 } }}
        >
          <Box
            sx={{
              display: 'flex',
              padding: '4px 8px',
              alignItems: 'center',
              borderRadius: rucksack.shape.borderRadius,
              background: rucksack.palette.Tooltip.bg,
            }}
          >
            <Typography
              sx={{
                color: rucksack.palette.common.white,
                fontSize: '.625rem',
                fontWeight: 500,
                whiteSpace: 'pre-line',
              }}
            >
              {text}
            </Typography>
          </Box>
        </Menu>
      </Box>
    </Box>
  )
}

interface PodMemberButtonProps {
  constructionName: string | null
  analystName: string | null
  driverName: string | null
  contractsName: string | null
  searchString?: string
}
